import { jsx, jsxs } from 'react/jsx-runtime';
import { Completed, Attention, Clear, Info, Close as Close$1 } from '@dls/assets/icons';
import { theme, Text, TextLink } from '@dls/web';
import { SCAlertRoot, SCAlertIcon, SCAlertBody, SCAlertAction } from './styles.js';
const iconMapping = {
  success: /* @__PURE__ */jsx(Completed, {
    color: theme.main.colours.successGreen,
    size: 24
  }),
  warning: /* @__PURE__ */jsx(Attention, {
    color: theme.main.colours.black,
    size: 24
  }),
  error: /* @__PURE__ */jsx(Clear, {
    color: theme.main.colours.errorRed,
    size: 24
  }),
  info: /* @__PURE__ */jsx(Info, {
    color: theme.main.colours.secondary.d2,
    size: 24
  })
};
const AlertBox = props => {
  const {
    children,
    title,
    className,
    severity,
    closable,
    onClose
  } = props;
  return /* @__PURE__ */jsxs(SCAlertRoot, {
    severity,
    className,
    children: [severity && /* @__PURE__ */jsx(SCAlertIcon, {
      children: iconMapping[severity]
    }), /* @__PURE__ */jsxs("div", {
      children: [title && /* @__PURE__ */jsx(Text, {
        type: "boldBody",
        children: title
      }), /* @__PURE__ */jsx(SCAlertBody, {
        children
      })]
    }), closable && onClose ? /* @__PURE__ */jsx(SCAlertAction, {
      children: /* @__PURE__ */jsx(TextLink, {
        onClick: onClose,
        inline: true,
        children: /* @__PURE__ */jsx(TextLink.Icon, {
          icon: Close
        })
      })
    }) : null]
  });
};
const Close = () => {
  return /* @__PURE__ */jsx(Close$1, {
    size: 20,
    color: "currentColor"
  });
};
export { AlertBox as default };